import { useEffect, useState } from "react";
import { DynamicFormControl } from "../../../";
import { DatePicker } from "@mui/x-date-pickers";
import { TextField } from "@mui/material";
import dayjs, { Dayjs } from 'dayjs';
import { getLocalizedStringMethods, localizeText, useTranslateDetection } from "../../helpers/translate-helper";
import { LocalizedStringsMethods } from "react-localization";
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

function DateControl(props: DynamicFormControl) {
    const defaultValue = props.defaultValue === 'current' ? dayjs().format('MM/DD/YYYY') : props.value;
    
    const [value, setValue] = useState<string | null>(defaultValue ?? null);
    const [maxDate, setMaxDate] = useState<Dayjs | undefined>(undefined);

    const { currentLanguage } = useTranslateDetection();
    let strings: LocalizedStringsMethods | null = getLocalizedStringMethods(props, currentLanguage);
    let label = props.label;

    if (strings != null && label != null) {
        const localization = localizeText(strings, label);
        label = localization.localization;
    }

    const handleChange = (event: any) => {
        const dateString = event?.format('MM/DD/YYYY') ?? null;
        if (props.setState) {
            props.setState(dateString);
        }

        setValue(dateString);
    };

    if (props.updater != null) {
        props.updater.setValue = value => {
            setValue(value === '' ? null : value);
        };
    }

    useEffect(() => {
        if (props.maxValue) {
            let max: Dayjs;

            if (props.maxValue === "today") {
                max = dayjs();
            } else {
                max = dayjs(props.maxValue);
            }

            setMaxDate(max);
        }
        if (defaultValue && props.setState) {
            props.setState(defaultValue);
        }
    }, [props.maxValue, defaultValue]);

    return (
        <DatePicker
            value={value ? dayjs(value) : undefined}
            onChange={handleChange}
            autoFocus={props.autoFocus}
            disabled={props.disabled}
            label={label}
            maxDate={maxDate}
            key={label}
            format={props.format ?? 'MM/DD/YYYY'}
            slotProps={{
                textField: {
                    required: props.required,
                    fullWidth: props.fullWidth,
                    id: props.id,
                    name: props.name,
                    size: props.size
                }
            }}
        // slots={{
        //     textField: (inputProps) => <TextField {...inputProps} fullWidth={props.fullWidth} id={props.id} name={props.name} placeholder={props.placeholder} required={props.required} size={props.size} />
        // }}
        // renderInput={(inputProps: any) => <TextField {...inputProps} fullWidth={props.fullWidth} id={props.id} name={props.name} placeholder={props.placeholder} required={props.required} size={props.size} />}
        />
    )
}


export default DateControl;
